// removed by extract-text-webpack-plugin
module.exports = {"vpTextInputContainer":"vpTextInputContainer___2Gfe3","vpTextInputLabel":"vpTextInputLabel___1GARV","vpCheckError":"vpCheckError___16G6U","vpOkNotTouched":"vpOkNotTouched___2DXUq","vpOkTouched":"vpOkTouched___2fMlS","vpCustomInput":"vpCustomInput___1w8_V","vpInvalidField":"vpInvalidField___12jag","vpErrorMessage":"vpErrorMessage___1YCiG","vpRequiredLabel":"vpRequiredLabel___1Jbwi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/TextAreaInput.module.less
// module id = 3767
// module chunks = 33